<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
      id="editModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Edit Invoice"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title">Title</label>
                      <validation-provider
                          #default="{ errors }"
                          name="title"
                          rules="required"
                      >
                        <b-form-input
                            id="title"
                            v-model="editedInvoice.title"
                            name="title"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title">Price</label>
                      <validation-provider
                          #default="{ errors }"
                          name="price"
                          rules="required"
                      >
                        <b-form-input
                            id="price"
                            type="number"
                            step="0.01"
                            v-model="editedInvoice.price"
                            name="price"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Reference Number</label>
                      <validation-provider
                          #default="{ errors }"
                          name="referenceNumber"
                          rules="required"
                      >
                        <b-form-input
                            id="referenceNumber"
                            v-model="editedInvoice.referenceNumber"
                            name="referenceNumber"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Date</label>
                      <validation-provider
                          #default="{ errors }"
                          name="date"
                          rules="required"
                      >
                        <b-form-datepicker
                            v-model="editedInvoice.date"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            menu-class="w-100"
                            calendar-width="100%"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Due Date</label>
                      <validation-provider
                          #default="{ errors }"
                          name="dueDate"
                          rules="required"
                      >
                        <b-form-datepicker
                            v-model="editedInvoice.dueDate"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            menu-class="w-100"
                            calendar-width="100%"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Status</label>
                      <validation-provider
                          #default="{ errors }"
                          name="status"
                          rules="required"
                      >
                        <v-select
                            v-model="editedInvoice.status"
                            name="status"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="invoiceStatus"
                            :reduce="name => name.id"
                            label="name"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">File</label>
                      <a
                          v-if="invoice && invoice.file"
                          :href="invoice && invoice.file && invoice.file.url"
                          target="_blank"
                      ><small style=" float: right;">View Old File?</small></a>
                      <validation-provider
                          #default="{ errors }"
                          name="file"
                          rules=""
                      >
                        <b-form-file
                            ref="file"
                            v-model="editedInvoice.file"
                            :file-name-formatter="formatNames"
                            accept=".pdf"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="textarea-default">Description  «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Description En"
                          rules="required"
                      >
                        <template>
                          <b-form-textarea
                              id="textarea-default"
                              v-model="editedInvoice.description"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group class="arabic-font">
                      <label for="descriptionAR">Description  «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          description_ar
                          name="Description AR"
                          rules="required"
                      >
                        <b-form-textarea
                            id="descriptionAR"
                            v-model="editedInvoice.descriptionAR"
                            class="arabic-font"
                            :class="errors&&errors.length > 0 ? 'is-invalid arabic-font' : 'valid arabic-font'"
                            placeholder=""
                            rows="5"
                            cols="12"
                            :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormFile, BFormDatepicker

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import invoiceService from '@/services/invoiceService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import representativeService from '@/services/representativeService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['invoice'],
  data() {
    return {
      editedInvoice: {
        referenceNumber: '',
        title: '',
        price: '',
        date: '',
        dueDate: '',
        status: '',
        description: '',
        descriptionAR: '',
        file: null,
      },
      invoiceStatus: [{name: 'Paid', id:2}, {name: 'Pending', id:1}],
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        maxFiles: 1,
      },
      codeBasic,
      selected: '',
    }
  },
  mounted() {
    this.$watch(() => this.invoice, invoice => {
      console.log('====>', invoice)
      this.editedInvoice= {
            referenceNumber: invoice.referenceNumber,
            title: invoice.title,
            price: parseFloat(invoice.price),
            date: invoice.date,
            status: invoice.status.id,
            description: invoice.description,
            descriptionAR: invoice.descriptionAR,
            dueDate: invoice.dueDate,
            file: null,
      }
    })
  },
  methods: {
    formatNames(files){
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      console.log('editedInvoice', this.editedInvoice)
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {

              invoiceService.put(this.$route.params.id, this.invoice.id, this.editedInvoice)
                  .then(response => {
                    this.$emit('refresh', 'true')
                    this.editedInvoice= {
                      reference_number: '',
                      title: '',
                      price: '',
                      date: '',
                      dueDate: '',
                      status: '',
                      description: '',
                      descriptionAR: '',
                      file: null
                    }
                    if(response && response.status === 200){
                      $('#editModal') .modal('hide')
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Invoice Is Updated Successfully !`,
                        },
                      })
                    }

                    this.loading = false
                    console.log('testing')
                  })
            }})
          .catch(
              function (error) {
                console.log('Show error notification!', error)
                $('#editModal').modal('hide')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'Error',
                    text: `Error !`,
                  },
                })
                return Promise.reject(error)
              }
          )
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
.arabic-font{
  font-family: arabic-font!important;
}
</style>
